import * as React from 'react';
import CartContext from '../../../Context/CartContext';
import { Cart } from '../../../Core/Api/Kopp/Api';
import { CartHandler } from '../CartHandler';
import useInterval from '../../../Core/useInterval';
import AuthContext from 'Context/AuthContext';
import { AuthUser } from 'Core/models/AuthUser';
import { debounce} from 'lodash';


export interface Props {
  children?: React.ReactNode;
}

export interface State {
  cart?: Cart;
  user?: AuthUser;
}

export default class CartContextProvider extends React.Component<Props, State> {
  static contextType = AuthContext;
  context!: React.ContextType<typeof AuthContext>;
  cartHandler: CartHandler | undefined;

  update: (newCart?: Cart) => void;

  constructor(props: Props) {
    super(props);
    this.state = { cart: undefined, user : this.context?.data };
    this.update = newCart => this.setState({ cart: newCart });
    this.cartHandler = new CartHandler(props);
    this.getCartForUser = debounce(this.getCartForUser.bind(this),100);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps: Props, prevState: State) {
    if(this.context.data?.username !== prevState.user?.username && this.context.data)
    {
      this.setState({ user: this.context.data});
      this.getCartForUser();
    }
  }

  getCartForUser() {
    this.cartHandler?.GetCart().then(x=> {
      this.setState({cart: x?.cart});
    })
  }

  render() {
    return (
      <CartContext.Provider value={{ Update: this.update, data: this.state.cart }}>
        {this.props.children}
      </CartContext.Provider>
    );
  }
}
